import React from 'react';
import { Divider } from 'semantic-ui-react';

import './style.scss';

interface SettingsRowProps {
  title: React.ReactNode;
  children: React.ReactNode;
  noDivider?: boolean;
}

export default function SettingsRow({ title, children, noDivider }: SettingsRowProps) {
  return (
    <>
      <div className="settings-row">
        <div className="settings-row__title">{title}</div>
        <div className="settings-row__value">{children}</div>
      </div>
      {!noDivider && <Divider />}
    </>
  );
}
